import { useTranslation } from "react-i18next";
import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup } from "@mui/material";
import { useField } from "formik";

interface RadioButton {
    value: string,
    label: string
}

const FormRadioGroup = ({
    name,
    label,
    readOnly = false,
    radioButtons
}: {
    name: string,
    label: string
    readOnly?: boolean,
    radioButtons: RadioButton[]
}) => {
    const {t} = useTranslation(['network', 'translation']);
    
    // Use Field
    const [field, meta, helper] = useField(name);

    return (
        <FormControl error={!!meta.error}>
            <FormLabel>{label}</FormLabel>
            <RadioGroup
                row
                name={name}
                value={field.value}
                onChange={(e, value) => {
                    !readOnly && helper.setValue(value);
                }}
            >
                {radioButtons.map(rb => (
                    <FormControlLabel
                        key={rb.value}
                        value={rb.value}
                        label={rb.label}
                        control={<Radio/>}
                        disabled={readOnly}
                    />
                ))}
            </RadioGroup>
            <FormHelperText>{t(meta.error as string)}</FormHelperText>
        </FormControl>
    )
};

export default FormRadioGroup;
